var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyRank fs20"},[_c('div',{staticClass:"tb"},_vm._l((_vm.info),function(v,k){return _c('div',{staticClass:"column"},[_c('div',[_vm._v(_vm._s(k))]),_c('div',[_vm._v(_vm._s(v))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }